var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWesternUnionLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 200,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.146 48.859 c 0.926 1.6 2.441 1.6 3.363 0 l 0.516 -0.894 l -4.63 -8.022 H 0 C 0 39.944 5.146 48.859 5.146 48.859 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,221,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14.902 45.432 c -0.337 0.581 -1.133 0.581 -1.47 0 l -3.172 -5.487 H 5.861 l 5.154 8.915 c 0.926 1.6 2.437 1.6 3.363 0 l 3.448 -5.975 l -1.698 -2.945 h -4.395 C 11.734 39.94 14.902 45.432 14.902 45.432 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,221,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 29.174 41.049 l -0.012 0.049 c -0.926 3.562 -1.279 5.004 -1.442 5.926 c -0.187 -0.987 -0.589 -2.616 -1.454 -5.926 l -0.012 -0.049 h -1.458 l -0.012 0.049 c -0.902 3.529 -1.279 5.04 -1.442 6.019 c -0.179 -0.954 -0.573 -2.538 -1.474 -6.019 l -0.012 -0.049 h -1.45 l 2.108 7.802 l 0.016 0.045 h 1.499 l 0.012 -0.049 c 0.926 -3.432 1.304 -4.898 1.458 -5.808 c 0.15 0.906 0.512 2.392 1.397 5.808 l 0.012 0.049 h 1.531 l 2.132 -7.847 H 29.174 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 32.858 43.003 c -0.824 0 -1.56 0.309 -2.092 0.865 c -0.528 0.552 -0.82 1.316 -0.82 2.145 c 0 1.763 1.235 2.993 2.997 2.993 c 1.133 0 2.205 -0.617 2.636 -1.539 l -1.036 -0.528 h -0.02 l -0.02 0.037 c -0.126 0.26 -0.585 0.865 -1.547 0.865 c -0.873 0 -1.539 -0.556 -1.641 -1.365 h 4.456 v -0.061 c 0.028 -1.101 -0.272 -2.002 -0.865 -2.608 C 34.393 43.279 33.682 43.003 32.858 43.003 z M 31.315 45.407 c 0.093 -0.735 0.731 -1.263 1.543 -1.263 c 0.825 0 1.454 0.528 1.519 1.263 H 31.315 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.828 45.387 c -0.654 -0.171 -1.219 -0.317 -1.219 -0.731 c 0 -0.333 0.353 -0.569 0.857 -0.569 c 0.552 0 0.934 0.292 0.999 0.76 l 0.041 0.236 h 0.024 l 1.162 -0.219 c 0 -1.089 -0.963 -1.852 -2.214 -1.852 c -1.251 0 -2.185 0.711 -2.185 1.726 c 0 1.231 1.141 1.535 2.059 1.779 c 0.666 0.179 1.239 0.333 1.239 0.764 c 0 0.378 -0.37 0.609 -0.963 0.609 c -0.715 0 -1.194 -0.333 -1.255 -0.869 l -0.012 -0.089 l -1.231 0.232 c 0.008 1.206 1.34 1.844 2.457 1.844 c 1.458 0 2.364 -0.678 2.364 -1.771 C 40.953 45.939 39.775 45.635 38.828 45.387 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 43.276 47.544 v -3.314 h 0.894 l -0.012 -1.105 H 43.28 v -1.641 l -1.283 0.321 v 1.32 h -0.67 v 1.105 h 0.67 v 3.599 h -0.004 c 0 0.65 0.41 1.178 1.093 1.178 c 0.845 0 1.093 -0.11 1.093 -0.11 v -1.093 c 0 0 -0.252 0.041 -0.56 0.041 C 43.418 47.844 43.276 47.722 43.276 47.544 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 52.057 43.856 v -0.731 h -1.129 v 5.771 h 1.357 l -0.012 -3.53 c 0.016 -0.353 0.138 -0.625 0.353 -0.808 c 0.284 -0.24 0.731 -0.321 1.32 -0.24 l 0.069 0.008 l 0.012 -1.202 l -0.057 -0.008 C 53.162 43.003 52.427 43.25 52.057 43.856 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 57.719 43.007 c -0.816 0 -1.58 0.325 -1.962 0.942 v -0.824 h -1.174 v 5.771 h 1.369 v -3.099 c 0 -0.995 0.52 -1.588 1.393 -1.588 c 0.597 0 1.308 0.26 1.308 1.503 v 3.184 h 1.369 v -3.371 C 60.022 43.669 58.828 43.007 57.719 43.007 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 67.377 45.647 c 0 1.332 -0.634 2.067 -1.779 2.067 c -1.145 0 -1.767 -0.735 -1.767 -2.067 v -4.598 H 62.45 v 4.565 c 0 2.124 1.178 3.391 3.148 3.391 c 1.97 0 3.148 -1.267 3.148 -3.391 v -4.565 h -1.369 V 45.647 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.698 43.007 c -0.816 0 -1.584 0.325 -1.962 0.942 v -0.824 h -1.178 v 5.771 h 1.369 v -3.099 c 0 -0.995 0.52 -1.588 1.393 -1.588 c 0.597 0 1.308 0.26 1.308 1.503 v 3.184 h 1.369 v -3.371 C 75.001 43.669 73.811 43.007 72.698 43.007 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.85,
    y: 43.13,
    rx: 0,
    ry: 0,
    width: 1.36,
    height: 5.77,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76.532 40.996 c -0.443 0 -0.792 0.341 -0.792 0.78 s 0.353 0.768 0.792 0.768 s 0.78 -0.345 0.78 -0.768 C 77.312 41.346 76.962 40.996 76.532 40.996 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 80.882 43.007 c -0.845 0 -1.616 0.305 -2.177 0.853 c -0.556 0.552 -0.865 1.312 -0.865 2.145 c 0 1.738 1.279 3.001 3.042 3.001 c 1.763 0 3.05 -1.263 3.05 -3.001 c 0 -0.833 -0.309 -1.596 -0.865 -2.145 C 82.506 43.307 81.731 43.007 80.882 43.007 z M 80.882 47.759 c -0.979 0 -1.714 -0.755 -1.714 -1.755 s 0.735 -1.755 1.714 -1.755 c 0.979 0 1.734 0.755 1.734 1.755 S 81.869 47.759 80.882 47.759 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 87.701 43.007 c -0.816 0 -1.58 0.325 -1.962 0.942 v -0.824 h -1.178 v 5.771 h 1.369 v -3.099 c 0 -0.995 0.52 -1.588 1.393 -1.588 c 0.597 0 1.308 0.26 1.308 1.503 v 3.184 H 90 v -3.371 C 90.004 43.669 88.814 43.007 87.701 43.007 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 47.431 43.007 c -0.816 0 -1.56 0.309 -2.092 0.865 c -0.528 0.552 -0.82 1.316 -0.82 2.145 c 0 1.759 1.231 2.989 2.997 2.989 c 1.133 0 2.205 -0.617 2.636 -1.539 l -1.036 -0.528 h -0.02 l -0.02 0.037 c -0.126 0.26 -0.585 0.865 -1.547 0.865 c -0.873 0 -1.539 -0.556 -1.641 -1.365 h 4.456 v -0.061 c 0.028 -1.101 -0.272 -2.002 -0.865 -2.608 C 48.966 43.283 48.255 43.007 47.431 43.007 z M 45.883 45.407 c 0.093 -0.735 0.731 -1.263 1.547 -1.263 c 0.816 0 1.454 0.528 1.519 1.263 H 45.883 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWesternUnionLogo);
export default __webpack_public_path__ + "static/media/western-union-logo.691007bd5eb2e5cbb1ed90fe67e43666.svg";
export { ForwardRef as ReactComponent };